import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import messages from './lang/en'
import axios from 'axios'

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    if (this.locale !== 'ru') {
        // proceed to the default implementation
    }

    if (choice % 10 == 1 && choice % 100 != 11) {
        return 0;
    }

    if (choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)) {
        return 1;
    }

    return 2;
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'def', // set locale
    fallbackLocale: 'def',
    messages: {
        def: {}
    }
})

const loadedLanguages = ['def'] // our default language that is preloaded

function setI18nLanguage (lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang) {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    return fetch(`/lang_js/${lang}.json?v${new Date().getTime()}`)
        .then((r)=> {return r.json()})
        .then((messages) => {
            i18n.setLocaleMessage(lang, messages)
            loadedLanguages.push(lang)
            return setI18nLanguage(lang)
        })
}

export default i18n;
